import type { MentionPerson } from '@till-erp/platform/mentions';
import { cn } from '../../lib/utils.ts';

/** Shared Chatter/Chat person selection. Keyboard ownership stays with the containing input. */
export function PersonMentionList<T extends MentionPerson>({ id, people, activeIndex, onChoose, className }: {
  id: string; people: readonly T[]; activeIndex: number; onChoose: (person: T) => void; className?: string;
}) {
  return <ul id={id} role="listbox" aria-label="Person erwähnen" className={cn('m-0 flex max-h-56 list-none flex-col overflow-y-auto rounded-tile bg-card p-space-1 shadow-float', className)}>
    {people.map((person, index) => <li key={person.id} id={`${id}-${index}`} role="option" aria-selected={index === activeIndex}
      onMouseDown={(event) => { event.preventDefault(); onChoose(person); }}
      className={cn('flex min-h-11 cursor-pointer items-center rounded-field px-space-3 text-row text-ink', index === activeIndex && 'bg-tile')}>
      {person.displayName}
    </li>)}
  </ul>;
}
